module.exports = __webpack_public_path__ + "97bc35d407d97b7ab3b07e9ae2c47729.svg";